export enum FeatureEnum {
	NOTE = 'NOTE',
	CALLBACK_ON_CALLNOTE = 'CALLBACK_ON_CALLNOTE',
	ERROR = 'ERROR',
	FEEDBACK = 'FEEDBACK',
	/** The SIP order page opened from a customer-service link. */
	SIP_ORDER = 'SIP_ORDER',
}
